<script setup>
import app from '@/main'
import { useRouter, useRoute } from 'vue-router'

const props = defineProps({
  userId: {
    type: String,
    required: true
  }
})

const router = useRouter()
const route = useRoute()

async function moreContentClicked () {
  const { data } = await app.wsp.sendRequest({
    data: {
      userId: props.userId
    },
    method: 'moreContent.clicked'
  })

  if (route.name === 'CreatorView') {
    if (data.autoMessageSent) {
      router.push('/chat/' + props.userId)
    } else {
      router.push(`/chat/${props.userId}/attachments/`)
    }
  } else {
    router.push('/chat/' + props.userId)
  }
}
</script>

<template>
  <button
    type="button"
    class="whitespace-nowrap flex items-center justify-center gap-1.5 px-3 py-2 border border-primary rounded-md text-sm font-bold text-primary hover:text-white hover:bg-primary"
    @click="moreContentClicked">
    <span>{{ $t('common.more_content') }}</span>

    <InlineSvg
      v-if="$i18n.locale === 'en'"
      class="w-4 h-4"
      :src="require('@/assets/fontawesome/regular/image-polaroid.svg')"/>
  </button>
</template>